import defaultValues from './origin-defaults';

/**
 *
 */

export default function origin(input) {
  var _ref = input || {},
    originData = _ref.origin;
  return originData;
}
export var defaultValue = defaultValues;